import type { ReactNode } from 'react';

interface SchemaOrgJsonLdProps {
  schema: Record<string, unknown>;
}

export default function SchemaOrgJsonLd({ schema }: SchemaOrgJsonLdProps): ReactNode {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}